export const hybridSearchFields: Record<string, any> = reactive({
  id: '',
  businessName: '',
  placeName: '',
  clusterPlaceName: null,
  fullname: '',
  phone: '',
  tradingName: '',
  maxLoadingCluster: null,
  maxUnloadingRoute: null,
  isActive: null,
  verified: null,
  isDocsVerified: null,
  landlines: '',
  email: null,
  balance: null,
})

export const hybridUserTableOptions: Record<string, any> = reactive({
  page: 1,
  results: 10,
  sortField: null,
  sortOrder: null,
  search: false,
})

export const resetHybridSearchFields = { ...hybridSearchFields }

export const hybridUsersListColumns = [
  {
    column_name: 'Hybrid User ID',
    column_value: 'id',
  },
  {
    column_name: 'Business Name',
    column_value: 'business_name',
    is_bold: true,
  },
  {
    column_name: 'Business Area',
    column_value: 'place_name',
    is_bold: true,
  },
  {
    column_name: 'Name',
    column_value: 'fullname',
  },
  {
    column_name: 'Trading Name',
    column_value: 'trading_name',
    is_bold: true,
  },
  {
    column_name: 'Business Cluster',
    column_value: 'clusters_place_name',
    is_bold: true,
  },
  {
    column_name: 'Mobile No.',
    column_value: 'phone',
  },
  {
    column_name: 'Max. Loading Cluster',
    column_value: 'max_loading_cluster',
  },
  {
    column_name: 'Verification',
    column_value: 'verified',
  },
  {
    column_name: 'Email Address',
    column_value: 'email',
  },
  {
    column_name: 'Max. Unloading Route',
    column_value: 'max_unloading_route',
  },
  {
    column_name: 'Doc Verification',
    column_value: 'is_docs_verified',
  },
  {
    column_name: 'Landline No.',
    column_fun: 'landLineNo',
    column_value: '',
  },
  {
    column_name: 'No. of Trucks',
    column_fun: '',
    column_value: '',
  },
  {
    column_name: '',
    column_fun: '',
    column_value: '',
  },
  {
    column_name: 'Created Timestamp',
    column_value: 'created_at',
  },
  {
    column_name: 'No. of Confirmations',
    column_fun: '',
    column_value: '',
  },
  {
    column_name: 'Status',
    column_value: 'is_active',
  },
  {
    column_name: 'Updated Timestamp',
    column_value: 'updated_at',
  },
  {
    column_name: 'Notes',
    column_fun: '',
    column_value: 'note',
  },
  {
    column_name: 'Balance',
    column_fun: '',
    column_value: 'available_balance',
    is_bold: true,
  },
]

export const addOptions = [
  {
    title: 'Add Load',
    value: 'load',
  },
  {
    title: 'Add Offer',
    value: 'offer',
  },
]

export const hybridProfileColumns = [
  { name: 'Hybrid User ID', value: 'id' },
  { name: 'Business Name', value: 'business_name' },
  { name: 'Trading Name', value: 'trading_name' },
  { name: 'Address', value: 'address' },
  { name: 'Business Area', value: 'place_name' },
  { name: 'Business GST IN', value: 'gst' },
  { name: 'PAN No.', value: 'pan' },
  { name: 'Email Id', value: 'user_id', subValue: 'email' },
  { name: 'Designation', value: 'designation' },
  { name: 'Mobile No.', value: 'mobiles' },
  { name: 'Landline No.', value: 'landline' },
  { name: 'Website', value: 'web' },
]

export const hybridProfileColumnsForOperator = [
  { name: 'Hybrid User ID', value: 'id' },
  { name: 'Business Name', value: 'business_name' },
  { name: 'Trading Name', value: 'trading_name' },
  { name: 'Address', value: 'address' },
  { name: 'Business Area', value: 'place_name' },
  { name: 'Business GST IN', value: 'gst' },
  { name: 'PAN No.', value: 'pan' },
  { name: 'Email Id', value: 'user_id', subValue: 'email' },
  { name: 'Designation', value: 'designation' },
  { name: 'Mobile No.', value: 'mobiles' },
  { name: 'Landline No.', value: 'landline' },
  { name: 'Balance', value: 'available_balance' },
]

export const hybridUsersVerifications = [
  { key: 'mobile', value: '20% - Mobile no. verified' },
  { key: 'email', value: '20% - Email address verified' },
  { key: 'hybrid', value: '10% - Hybrid users documents verified', subKey: 'hybrid_count' },
  { key: 'employee', value: '10% - Employee documents verified', subKey: 'employee_count' },
  { key: 'branch', value: '10% - Branch documents verified', subKey: 'branch_count' },
  { key: 'truck', value: '10% - Truck documents verified', subKey: 'truck_count' },
  { key: 'driver', value: '10% - Driver documents verified', subKey: 'driver_count' },
  { key: 'bank', value: '10% - Bank documents verified', subKey: 'bank_count' },
]

export const hybridUsersTabs = [
  { icon: 'tabler-user', title: 'Employees', key: 'employee_count', type: 'employees', msgKey: 'employees', msgType: 'employee', moduleType: 'loader' },
  { icon: 'tabler-truck', title: 'Branches', key: 'branch_count', type: 'branches', msgKey: 'branches', msgType: 'branch', moduleType: 'loader' },
  { icon: 'tabler-user', title: 'Drivers', key: 'driver_count', type: 'drivers', msgKey: 'drivers', msgType: 'driver', moduleType: 'trucker' },
  { icon: 'tabler-truck', title: 'Trucks', key: 'truck_count', type: 'trucks', msgKey: 'trucks', msgType: 'truck', moduleType: 'trucker' },
  { icon: 'tabler-square-chevron-down', title: 'Loads', key: 'load_count', type: 'loads', msgKey: 'loads', msgType: 'load', moduleType: 'loader' },
  { icon: 'tabler-square-chevron-down', title: 'Offers', key: 'offer_count', type: 'offers', msgKey: 'offers', msgType: 'offer', moduleType: 'trucker' },
  { icon: 'tabler-building-bank', title: 'Banks', key: 'bank_count', type: 'banks', msgKey: 'banks', msgType: 'bank', moduleType: 'account' },
  { icon: 'tabler-clipboard-text', title: 'Ledgers', type: 'ledger', msgKey: 'ledgers', msgType: 'ledger', moduleType: 'account' },
  { icon: 'tabler-notebook', title: 'MC Books', type: 'mc-book', msgKey: 'mc books', module: 'MC Book', msgType: 'mc book', moduleType: 'admin' },
]

export const hybridTabs = [
  { icon: 'tabler-user', title: 'Employees', key: 'employee_count', type: 'employees', msgKey: 'employees', msgType: 'employee', moduleType: 'loader' },
  { icon: 'tabler-truck', title: 'Customers', key: 'branch_count', type: 'branches', msgKey: 'branches', msgType: 'branch', moduleType: 'loader' },
  { icon: 'tabler-user', title: 'Drivers', key: 'driver_count', type: 'drivers', msgKey: 'drivers', msgType: 'driver', moduleType: 'trucker' },
  { icon: 'tabler-truck', title: 'Trucks', key: 'truck_count', type: 'trucks', msgKey: 'trucks', msgType: 'truck', moduleType: 'trucker' },
  { icon: 'tabler-square-chevron-down', title: 'Loads', key: 'load_count', type: 'loads', msgKey: 'loads', msgType: 'load', moduleType: 'loader' },
  { icon: 'tabler-square-chevron-down', title: 'Offers', key: 'offer_count', type: 'offers', msgKey: 'offers', msgType: 'offer', moduleType: 'trucker' },
  { icon: 'tabler-building-bank', title: 'Banks', key: 'bank_count', type: 'banks', msgKey: 'banks', msgType: 'bank', moduleType: 'account' },
  { icon: 'tabler-clipboard-text', title: 'Ledgers', type: 'ledger', msgKey: 'ledgers', msgType: 'ledger', moduleType: 'account' },
]
